import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

export default function TermsConditions() {

  return (
    <>
      <SEO
        title="Terms and Conditions - Online Tools Center"
        description="Read the terms and conditions for using Online Tools Center."
        keywords="terms and conditions, website usage policy"
        url="https://online-tools-center.vercel.app/terms-conditions"
      />

      <Navbar />

      {/* HERO */}

      <section
        style={{
          background:
            "linear-gradient(135deg,#0f172a,#1e293b)",
          color: "white",
          padding:
            "70px 20px",
        }}
      >

        <div className="container text-center">

          <h1
            className="fw-bold mb-3"
            style={{
              fontSize:
                "clamp(2.5rem,5vw,4rem)",
            }}
          >
            Terms & Conditions
          </h1>

          <p
            className="lead mx-auto"
            style={{
              maxWidth: "800px",
            }}
          >
            Please read these terms carefully
            before using Online Tools Center.
          </p>

        </div>

      </section>

      {/* CONTENT */}

      <div className="container py-5">

        <div
          className="card border-0 shadow-lg rounded-4 p-4 p-md-5"
        >

          <p className="text-muted">
            Last Updated:
            {" "}
            {new Date().getFullYear()}
          </p>

          <h2 className="fw-bold mt-4">
            Acceptance of Terms
          </h2>

          <p className="text-muted">
            By accessing or using this website,
            you agree to comply with
            these Terms & Conditions.
          </p>

          <h2 className="fw-bold mt-5">
            Website Usage
          </h2>

          <p className="text-muted">
            You may use our tools
            for personal,
            educational,
            and informational purposes.
          </p>

          <h2 className="fw-bold mt-5">
            Accuracy Disclaimer
          </h2>

          <p className="text-muted">
            While we try to provide
            accurate calculations and tools,
            we do not guarantee
            complete accuracy of results.
          </p>

          <h2 className="fw-bold mt-5">
            Intellectual Property
          </h2>

          <p className="text-muted">
            All website content,
            branding,
            design,
            and code remain
            the property of
            Online Tools Center.
          </p>

          <h2 className="fw-bold mt-5">
            Third-Party Services
          </h2>

          <p className="text-muted">
            This website may use
            third-party services
            including analytics,
            advertisements,
            and hosting providers.
          </p>

          <h2 className="fw-bold mt-5">
            Limitation of Liability
          </h2>

          <p className="text-muted">
            We are not liable
            for any damages,
            losses,
            or issues resulting
            from the use of this website.
          </p>

          <h2 className="fw-bold mt-5">
            Changes to Terms
          </h2>

          <p className="text-muted">
            We may modify these terms
            at any time without notice.
          </p>

          <h2 className="fw-bold mt-5">
            Contact Information
          </h2>

          <div className="alert alert-primary">
            emicalculator.official@gmail.com
          </div>

        </div>

      </div>

      <Footer />

    </>
  );
}